var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgregar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#148f9f;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_349",
    "data-name": "Grupo 349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_569",
    "data-name": "Rect\\xE1ngulo 569",
    className: "cls-1",
    d: "M23,0h1A23,23,0,0,1,47,23h0A23,23,0,0,1,24,46H23A23,23,0,0,1,0,23H0A23,23,0,0,1,23,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_4",
    "data-name": "Uni\\xF3n 4",
    className: "cls-2",
    d: "M20.66,32.66V24.34H12.35a2.34,2.34,0,1,1,0-4.68h8.32V11.35a2.35,2.35,0,1,1,4.69,0v8.31h8.31a2.35,2.35,0,0,1,0,4.69H25.34v8.31a2.34,2.34,0,0,1-4.68,0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgregar);
export default __webpack_public_path__ + "static/media/Agregar.d00f7b099ec70ffd860ee5625847f2d6.svg";
export { ForwardRef as ReactComponent };